import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, Col, Container, Row } from "react-bootstrap";
import RecommendedChannels from "../components/news/RecommendedChannels";
import SEO from "../components/seo/SEO";
import { fetchInternalNewsBySlug } from '../http/internalNewsAPI';

const NewsDetailPage = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [news, setNews] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let mounted = true;

        setLoading(true);
        setError("");

        fetchInternalNewsBySlug(slug)
            .then((data) => {
                if (!mounted) return;
                setNews(data);
            })
            .catch(() => {
                if (!mounted) return;
                setError("News not found");
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, [slug]);

    const renderState = (message, className = "text-muted") => (
        <Container fluid className="px-3 mt-3 mb-3">
            <Row className="justify-content-start">
                <Col xs={12} md={9} lg={9}>
                    <Card className="shadow-sm rounded p-3 bg-white">
                        <p className={`small mb-0 ${className}`}>{message}</p>
                    </Card>
                </Col>
                <Col md={3} lg={3} className="d-none d-md-block">
                    <Card className="shadow-sm rounded p-3 bg-white">
                        <RecommendedChannels />
                    </Card>
                </Col>
            </Row>
        </Container>
    );

    if (loading) return renderState("Loading news...");
    if (error || !news) return renderState(error || "News not found", "text-danger");

    const pageAbsUrl = `https://virtalibry.com/news/${news.slug}`;
    const imageUrl = news.image;

    return (
        <>
            <SEO
                title={news.title}
                description={news.summary || ""}
                url={pageAbsUrl}
                canonical={pageAbsUrl}
                image={news.image}
                twitterImage={news.image}
                type="article"
            />

            <Container fluid className="px-3 mt-3 mb-3">
                <Row>
                    <Col xs={12} sm={12} md={12} className="ms-0"><h1 className="fs-6"></h1></Col>
                </Row>
                <Row className="justify-content-start">
                    <Col xs={12} md={9} lg={9}>
                        <Card className="shadow-sm rounded p-3 bg-white">
                            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                                <div className="mb-2">
                                    <h5 className="mb-0">{news.title}</h5>
                                    <p className="text-muted fst-italic small mb-0">{news.date}</p>
                                </div>

                                <div className="text-end">
                                    <button
                                        className="btn btn-sm btn-outline-secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        &larr; Back to News
                                    </button>
                                </div>
                            </div>

                            <div>
                                <img
                                    src={imageUrl}
                                    alt={news.title}
                                    style={{
                                        float: 'left',
                                        width: '20%',
                                        maxWidth: '150px',
                                        maxHeight: '150px',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                        marginRight: '15px',
                                        marginBottom: '10px'
                                    }}
                                />

                                <div
                                    className="text-muted small"
                                    style={{ lineHeight: '1.6' }}
                                    dangerouslySetInnerHTML={{ __html: news.content }}
                                />
                            </div>

                            <div className="clearfix" />

                            <div className="text-end mt-4">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    onClick={() => navigate(-1)}
                                >
                                    &larr; Back to News
                                </button>
                            </div>
                        </Card>
                    </Col>
                    <Col md={3} lg={3} className="d-none d-md-block">
                        <Card className="shadow-sm rounded p-3 bg-white">
                            <RecommendedChannels />
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default NewsDetailPage;
